import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FooterContentFragment = { __typename?: 'NotificationLayout', footer?: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection', content: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName', content: string } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName', content: string } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp', content: string } | { __typename?: 'NotificationLayoutItemUserName' }> } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName' }> | null };

export const FooterContent = /*#__PURE__*/ gql`
    fragment FooterContent on NotificationLayout {
  footer {
    ... on NotificationLayoutItemSection {
      content {
        ... on NotificationLayoutItemTimestamp {
          content
        }
        ... on NotificationLayoutItemProjectName {
          content
        }
        ... on NotificationLayoutItemShareName {
          content
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<FooterContentFragment, unknown>;

        

        
export const useFooterContentFragment = (
  input: string | Omit<UseFragmentOptions<FooterContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayout' } };
    return input;
  })();

  return useFragment<FooterContentFragment>({
    fragment: FooterContent,
    fragmentName: 'FooterContent',
    ...options,
  });
};
  
        